import { Link } from "@inertiajs/react"
import type { PropsWithChildren } from "react"

import { rootPath } from "@/routes"

interface AuthLayoutProps {
  name?: string
  title?: string
  description?: string
}

export default function AuthSimpleLayout({
  children,
  title,
  description,
}: PropsWithChildren<AuthLayoutProps>) {
  return (
    <div className="bg-hpi-blue flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <Link href={rootPath()}>
        <img src="/HPI-Logo-White.svg" alt="HawkPI" className="h-16" />
      </Link>
      <div className="w-full max-w-sm rounded-xl bg-white p-8 shadow-lg">
        <div className="flex flex-col gap-8">
          <div className="flex flex-col items-center gap-4">
            <div className="space-y-2 text-center">
              <h1 className="text-xl font-medium">{title}</h1>
              <p className="text-muted-foreground text-center text-sm">
                {description}
              </p>
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
